import { z } from 'zod';

export const directoryQuerySchema = z.object({
  q: z.string().trim().max(100).optional(),
  cursor: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(100).default(25),
});
export type DirectoryQuery = z.infer<typeof directoryQuerySchema>;

export const contactSummarySchema = z.object({
  id: z.string(),
  name: z.string().nullable(),
  email: z.string(),
  leadCount: z.number().int(),
  lastLeadAt: z.string().nullable(),
});
export type ContactSummary = z.infer<typeof contactSummarySchema>;

export const companySummarySchema = z.object({
  id: z.string(),
  name: z.string(),
  domain: z.string().nullable(),
  industry: z.string().nullable(),
  country: z.string().nullable(),
  leadCount: z.number().int(),
  lastLeadAt: z.string().nullable(),
});
export type CompanySummary = z.infer<typeof companySummarySchema>;

export const contactListSchema = z.object({ items: z.array(contactSummarySchema), nextCursor: z.string().nullable() });
export const companyListSchema = z.object({ items: z.array(companySummarySchema), nextCursor: z.string().nullable() });
export type ContactList = z.infer<typeof contactListSchema>;
export type CompanyList = z.infer<typeof companyListSchema>;
